// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_errorboundaryheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Something went wrong`
};

const de_errorboundaryheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Etwas ist schiefgelaufen`
};

const es_errorboundaryheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Algo salió mal`
};

const fr_errorboundaryheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Quelque chose s'est mal passé`
};

const ja_errorboundaryheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `何かがうまくいきませんでした`
};

const nl_errorboundaryheading2 = /** @type {(inputs: {}) => string} */ () => {
	return `Er is iets misgegaan`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "ja" | "nl" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errorboundaryheading2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errorboundaryheading2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errorboundaryheading2", locale)
	if (locale === "en") return en_errorboundaryheading2(inputs)
	if (locale === "de") return de_errorboundaryheading2(inputs)
	if (locale === "es") return es_errorboundaryheading2(inputs)
	if (locale === "fr") return fr_errorboundaryheading2(inputs)
	if (locale === "ja") return ja_errorboundaryheading2(inputs)
	return nl_errorboundaryheading2(inputs)
};
export { errorboundaryheading2 as "errorBoundaryHeading" }